@if (
  {
    leftPixelPosition: item.accurateStartDateTime | ganttStartingPixel | async,
    rightPixelPosition:
      [item.accurateStartDateTime, item.accurateEndDateTime]
      | ganttEndingPixel
      | async,
  };
  as positionData
) {
  @if (
    {
      wrapperWidthPx:
        {
          left: positionData.leftPixelPosition,
          right: positionData.rightPixelPosition,
        }
        | timeDifferenceWidthPx: BORDER_SIZE
        | async,
    };
    as data
  ) {
    <div
      class="wrapper"
      [class.highlighted]="isHighlighted"
      [style.width.px]="data.wrapperWidthPx"
      [style.border-width.px]="ACTIVITY_BORDER_PX"
      [style.left.px]="positionData.leftPixelPosition"
    >
      <div class="d-flex justify-content-between">
        <div
          class="wrapper-details"
          [ngStyle]="{
            height: ACTIVITY_TITLE_HEIGHT_PX + 'px',
            'margin-top': ACTIVITY_TITLE_MARGIN_TOP_PX + 'px',
            'margin-bottom': ACTIVITY_TITLE_MARGIN_BOTTOM_PX + 'px',
          }"
        >
          <div class="wrapper-name">
            {{ name }}
          </div>
        </div>
      </div>
      @for (activities of activityWithOverlapLevel; track $index) {
        <wilson-auto-size-wrapper-for-data-with-activities
          [accurateStartDateTime]="item.accurateStartDateTime.toISOString()"
          [accurateEndDateTime]="item.accurateEndDateTime.toISOString()"
          [activities]="activities"
          [accurateContainerDurationMs]="accurateServiceDurationMs"
          [containerWidthPx]="
            {
              left: positionData.leftPixelPosition,
              right: positionData.rightPixelPosition,
            }
              | timeDifferenceWidthPx: BORDER_SIZE
              | async
          "
          [isActivityDraggable]="true"
        ></wilson-auto-size-wrapper-for-data-with-activities>
      }
    </div>
  }
}
